import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Chevron from "../icons/chevron";

const PillButtonContainer = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid #0074c2;
  background: ${({ isSelected, isActive }) => {
    if (isSelected) return "#eff8fc";
    if (isActive) return "#f5f5f5";
    return "#fff";
  }};
  color: #424242;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background: ${({ isSelected }) => (isSelected ? "#eff8fc" : "#f5f5f5")};
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(25, 152, 213, 0.2);
  }
`;

const ChevronWrapper = styled.div`
  margin-left: 8px;
  display: flex;
  align-items: center;
  transform: ${({ isActive }) =>
    isActive ? "rotate(90deg)" : "rotate(270deg)"};
  transition: transform 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
  }
`;

const PillButton = ({ label, isActive, isSelected, onClick }) => {
  return (
    <PillButtonContainer
      isActive={isActive}
      isSelected={isSelected}
      onClick={onClick}
      type={"button"}
    >
      {label}
      <ChevronWrapper isActive={isActive}>
        <Chevron />
      </ChevronWrapper>
    </PillButtonContainer>
  );
};

PillButton.propTypes = {
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default PillButton;
